// The featured service is a page setting, so Liquid does not apply ?variant.
// Restore through Horizon's normal change event to update both picker and form.
export function restoreServiceSelection(root, href = window.location.href) {
  const picker = root.querySelector('variant-picker');
  if (!picker) return;
  const id = new URL(href).searchParams.get('variant');
  if (!id) return;
  const radio = [...picker.querySelectorAll('input[type="radio"][data-variant-id]')]
    .find(input => input.dataset.variantId === id);
  if (!radio || radio.checked) return;
  radio.dispatchEvent(new Event('change', { bubbles: true }));
}

async function restore() {
  await customElements.whenDefined('variant-picker');
  document.querySelectorAll('.cr-glove-service').forEach(root => restoreServiceSelection(root));
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', restore, { once: true });
else restore();
window.addEventListener('pageshow', restore);
